import { fetchDispositivo } from "../http-common";
import { IDataTablet, IPersonaTablets } from "../../Interfaces/IEquipo";
import { Ifilter } from "../../Interfaces/filter";
import { IFormAsignacion } from "../../pages/personas/Dispositivos/ListDispositivos/ListaDispositivos";
import { IFilterCombo } from "../../Interfaces/IDispositivos";
import { IfilterDispositivos } from "../../Interfaces/dispositivo/IDispositivo";

/** API que trae todos los dispositivos */
const allTablets = (filter: Ifilter) => {
  return fetchDispositivo.get(`Dispositivo/Lista`, { params: filter });
};

/** API que trae todos los dispositivos Asigandos */

const asignarDispositivo = (data: IFormAsignacion) => {
  return fetchDispositivo.post(`DispositivoAsignado/Crear`, data);
};

const allDispositivobyID = (PersonaId: string) => {
  return fetchDispositivo.get(`Dispositivo/Lista/${PersonaId}`);
};

const allTabletsCombo = (filter: Ifilter) => {
  return fetchDispositivo.get<IDataTablet>(`Dispositivo/Lista`, {
    params: filter,
  });
};

const postPersonaTablets = (data: IPersonaTablets) => {
  //falta api
  return fetchDispositivo.post(`DispositivoAsignado/Asignar`, data);
};

const allPersonaTablets = (personaId: string) => {
  //falta api

  return fetchDispositivo.get(`DispositivoAsignado/${personaId}`);
};

const postComboDispositivoAndroid = (search: IFilterCombo) =>
  fetchDispositivo.post(`Dispositivo/ListarComboDispositivoAndroid`, search);

const postTableHistoricoDispositivo = (
  data: any,
  controller = new AbortController()
) => {
  return fetchDispositivo.post(`Dispositivo/ListarTableHistoricoDsp`, data, {
    signal: controller.signal,
  });
};

const listarTablets = (
  filter: IfilterDispositivos,
  constroller = new AbortController()
) => {
  return fetchDispositivo.get(`Dispositivo/Lista`, {
    params: filter,
    signal: constroller.signal,
  });
};

const dispositivoServicio = {
  allDispositivobyID,
  allTabletsCombo,
  postPersonaTablets,
  allPersonaTablets,
  allTablets,
  asignarDispositivo,
  postComboDispositivoAndroid,
  postTableHistoricoDispositivo,
  listarTablets,
};

export default dispositivoServicio;
